var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2580_226287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.5C8.5 0.223858 8.27614 0 8 0C7.72386 0 7.5 0.223858 7.5 0.5V2.52387C7.5 2.79208 7.7318 3 8 3C8.2682 3 8.5 2.79208 8.5 2.52387V0.5Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69511 3.00683C5.82911 3.23892 5.73106 3.53519 5.49912 3.66942C5.26698 3.80377 4.96326 3.73923 4.82916 3.50696L3.81757 1.75483C3.6795 1.51568 3.76143 1.20989 4.00058 1.07182C4.23973 0.933745 4.54552 1.01568 4.68359 1.25483L5.69511 3.00683Z",
    fill: "#000001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66953 5.49893C3.80389 5.26679 3.73936 4.96307 3.50707 4.82896L1.75434 3.81702C1.51519 3.67894 1.2094 3.76088 1.07133 4.00003C0.933257 4.23917 1.01519 4.54497 1.25434 4.68304L3.00695 5.69491C3.23903 5.8289 3.53529 5.73086 3.66953 5.49893Z",
    fill: "#000001"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52387 7.5C2.79208 7.5 3 7.7318 3 8C3 8.2682 2.79208 8.5 2.52388 8.5H0.5C0.223858 8.5 0 8.27614 0 8C0 7.72386 0.223858 7.5 0.5 7.5H2.52387Z",
    fill: "#000001"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66955 10.5011C3.53531 10.2692 3.23905 10.1711 3.00698 10.3051L1.25434 11.317C1.01519 11.4551 0.933257 11.7609 1.07133 12C1.2094 12.2392 1.51519 12.3211 1.75434 12.183L3.5071 11.1711C3.73938 11.037 3.80392 10.7332 3.66955 10.5011Z",
    fill: "#000001"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82829 12.4925C4.96241 12.2602 5.26618 12.1957 5.49833 12.3301C5.73022 12.4644 5.82822 12.7606 5.69424 12.9927L4.68243 14.7452C4.54436 14.9843 4.23857 15.0663 3.99942 14.9282C3.76027 14.7901 3.67834 14.4843 3.81641 14.2452L4.82829 12.4925Z",
    fill: "#000001"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13C7.7318 13 7.5 13.2079 7.5 13.4761V15.5C7.5 15.7761 7.72386 16 8 16C8.27614 16 8.5 15.7761 8.5 15.5V13.4761C8.5 13.2079 8.2682 13 8 13Z",
    fill: "#000001"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3057 12.9927C10.1718 12.7606 10.2698 12.4644 10.5017 12.3301C10.7338 12.1957 11.0376 12.2602 11.1717 12.4926L12.1836 14.2452C12.3217 14.4844 12.2397 14.7902 12.0006 14.9282C11.7614 15.0663 11.4556 14.9844 11.3176 14.7452L10.3057 12.9927Z",
    fill: "#000001"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3302 10.5015C12.1958 10.7336 12.2604 11.0374 12.4927 11.1715L14.2447 12.183C14.4839 12.3211 14.7897 12.2392 14.9277 12C15.0658 11.7609 14.9839 11.4551 14.7447 11.317L12.9928 10.3055C12.7607 10.1716 12.4645 10.2696 12.3302 10.5015Z",
    fill: "#000001"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4761 8.5C13.2079 8.5 13 8.2682 13 8C13 7.7318 13.2079 7.5 13.4761 7.5H15.5C15.7761 7.5 16 7.72386 16 8C16 8.27614 15.7761 8.5 15.5 8.5H13.4761Z",
    fill: "#000001"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3303 5.49857C12.4645 5.73047 12.7608 5.82849 12.9928 5.69451L14.7447 4.68304C14.9839 4.54497 15.0658 4.23918 14.9277 4.00003C14.7897 3.76088 14.4839 3.67895 14.2447 3.81702L12.4927 4.82855C12.2604 4.96267 12.1959 5.26642 12.3303 5.49857Z",
    fill: "#000001"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1708 3.50695C11.0367 3.73922 10.733 3.80376 10.5009 3.66941C10.2689 3.53518 10.1709 3.23891 10.3049 3.00682L11.3164 1.25479C11.4545 1.01564 11.7603 0.933706 11.9994 1.07178C12.2386 1.20985 12.3205 1.51564 12.1824 1.75479L11.1708 3.50695Z",
    fill: "#000001"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8ZM11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2580_226287)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunOutlined);
export default __webpack_public_path__ + "static/media/sun-outlined.01202b504c743c4adb8c77d694ba2c03.svg";
export { ForwardRef as ReactComponent };